// extracted by mini-css-extract-plugin
export default {"icon":"Notification_icon__IHk+0","alertDescription":"Notification_alertDescription__tu5eV"};